import { MailboxIdentityPanel } from "@ozpanel/kit";

// Profile: who you are to the people you write to — your name, title, phone, signature and photo. The
// same identity your account administrator sees and every webmail app reads (kit MailboxIdentityPanel).
export function Profile() {
  return (
    <div className="space-y-4">
      <MailboxIdentityPanel self title="Your profile" />
    </div>
  );
}
